import { render } from "./ItemDeletionNoticeModal.vue?vue&type=template&id=658e7216"
import script from "./ItemDeletionNoticeModal.vue?vue&type=script&lang=js"
export * from "./ItemDeletionNoticeModal.vue?vue&type=script&lang=js"

import "./ItemDeletionNoticeModal.vue?vue&type=style&index=0&id=658e7216&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__